module.exports = __webpack_public_path__ + "static/media/flags32.2e6ce38f.png";